"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWebPushVariantCommand = void 0;
const AbstractCreateVariantCommand_1 = require("./AbstractCreateVariantCommand");
class CreateWebPushVariantCommand extends AbstractCreateVariantCommand_1.AbstractCreateVariantCommand {
    constructor(api, appId) {
        super(api, appId, 'web_push');
        this.withPublicKey = (publicKey) => {
            this.def.publicKey = publicKey;
            return this;
        };
        this.withPrivateKey = (privateKey) => {
            this.def.privateKey = privateKey;
            return this;
        };
        this.withAlias = (alias) => {
            this.def.alias = alias;
            return this;
        };
        this.def.type = 'web_push';
    }
}
exports.CreateWebPushVariantCommand = CreateWebPushVariantCommand;
//# sourceMappingURL=CreateWebPushVariantCommand.js.map